var load_more_default = (() => {
    if (customElements.get("load-more")) return;
    customElements.define("load-more", class LoadMore extends HTMLElement {
        constructor() {
            super();
            this.section = this.dataset.section || "";
            this.mode = this.dataset.mode || "next";
            this.selectors = [ "[data-grid]", `[data-load-${this.mode}]` ];
        }
        connectedCallback() {
            this.button = this.querySelector("a");
            if (!this.button) return;
            this.loadMore = this.loadMore.bind(this);
            this.addEventListeners();
        }
        addEventListeners() {
            this.button.addEventListener("click", this.loadMore);
        }
        loadMore(event) {
            event.preventDefault();
            event.stopPropagation();
            if (this.button.hasAttribute("aria-busy")) return;
            this.button.setAttribute("aria-busy", "true");
            const oldButtonText = this.button.textContent;
            this.button.textContent = window.MBF.strings.loading || "Loading...";
            const method = this.mode?.includes("prev") ? "afterbegin" : "beforeend";
            const container = document.querySelector(`#shopify-section-${this.section}`) || document;
            const url = new URL(this.button.href);
            const searchParams = new URLSearchParams(url.search);
            searchParams.set("section_id", this.section);
            fetch(`${url.pathname}?${searchParams.toString()}`).then(response => response.text()).then(text => {
                const html = (new DOMParser).parseFromString(text, "text/html");
                this.selectors.forEach(selector => {
                    const oldEl = container.querySelector(selector);
                    if (oldEl) {
                        const newEl = html.querySelector(selector);
                        if (newEl) selector.toLowerCase().includes("grid") ? oldEl.insertAdjacentHTML(method, newEl.innerHTML) : oldEl.innerHTML = newEl.innerHTML; else oldEl.parentNode.removeChild(oldEl);
                    }
                });
                history.pushState({}, "", this.button.href);
            }).catch(error => {
                console.error(error);
                location.href = this.button.href;
            }).finally(() => {
                this.button.removeAttribute("aria-busy");
                this.button.textContent = oldButtonText;
            });
        }
    });
})();